export function sleep(ms) {
  const delay = typeof ms === 'number' && Number.isFinite(ms) ? ms : 0;
  return new Promise((resolve) => window.setTimeout(resolve, delay));
}

export function score_percent(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) return '--';
  return `${Math.round(Number(score) * 100)}%`;
}

export function as_record(value) {
  const result = value && typeof value === 'object' ? value : null;
  return result;
}

export function get_error_status(error) {
  const response = as_record(as_record(error)?.response);
  const status = typeof response?.status === 'number' ? response.status : null;
  return status;
}

export function get_error_message(error, fallback_message) {
  const response = as_record(as_record(error)?.response);
  const response_data = as_record(response?.data);
  const detail = typeof response_data?.detail === 'string' ? response_data.detail.trim() : '';
  if (detail) {
    return detail;
  }

  const error_record = as_record(error);
  const message = typeof error_record?.message === 'string' ? error_record.message.trim() : '';
  const resolved_message = message || fallback_message;
  return resolved_message;
}

export function normalize_signal(value) {
  const source = as_record(value);
  if (!source) return null;

  const normalized_signal = {
    decision: typeof source.decision === 'string' ? source.decision : '',
    score: typeof source.score === 'number' ? source.score : null
  };

  return normalized_signal;
}

export function normalize_challenge(value) {
  const source = as_record(value);
  if (!source) return null;

  const normalized_result = {
    code: typeof source.code === 'string' ? source.code : '',
    label: typeof source.label === 'string' ? source.label : '',
    instruction: typeof source.instruction === 'string' ? source.instruction : '',
    duration_ms: typeof source.duration_ms === 'number' ? source.duration_ms : 0
  };

  return normalized_result;
}

export function normalize_session(value) {
  const source = as_record(value);
  if (!source) return null;

  const challenges = Array.isArray(source.challenges)
    ? source.challenges.map((challenge) => normalize_challenge(challenge)).filter(Boolean)
    : [];

  const normalized_session = {
    session_id: typeof source.session_id === 'string' ? source.session_id : '',
    token: typeof source.token === 'string' ? source.token : '',
    challenges
  };

  return normalized_session;
}

export function normalize_result(value) {
  const source = as_record(value);
  if (!source) return null;

  const normalized_result = {
    decision: typeof source.decision === 'string' ? source.decision : '',
    quality: normalize_signal(source.quality),
    active_liveness: normalize_signal(source.active_liveness),
    capture_integrity: normalize_signal(source.capture_integrity),
    face_match: normalize_signal(source.face_match)
  };

  return normalized_result;
}

export function extract_result_payload(payload) {
  const source = as_record(payload);
  if (!source) return null;

  const nested_result = normalize_result(source.result_payload);
  const result = nested_result ?? normalize_result(source);
  return result;
}

export const CAMERA_CONSTRAINT_OPTIONS = [
  {
    audio: false,
    video: {
      facingMode: { ideal: 'user' },
      width: { ideal: 1280, min: 480 },
      height: { ideal: 720, min: 360 }
    }
  },
  {
    audio: false,
    video: {
      facingMode: 'user',
      width: { ideal: 960 },
      height: { ideal: 540 }
    }
  },
  {
    audio: false,
    video: {
      width: { ideal: 960 },
      height: { ideal: 540 }
    }
  },
  {
    audio: false,
    video: true
  }
];
